module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/node_modules/core-js/library/modules/_add-to-unscopables.js
// module id = 710
// module chunks = 0